const getParams = (_binId) => {
    let columnNumber, direction = 'F', rowNumber;
    const binId = parseInt(_binId, 10);
    columnNumber = Math.ceil(binId / 10);
    if (columnNumber > 8) {
        columnNumber -= 8;
        direction = 'B'
    }
    rowNumber = getRows(binId);
    return { columnNumber, direction, rowNumber }
}

const getRows = (binId) => {
    let rowNumber;
    if (binId.toString().length > 1) {
        if (
            binId.toString().length !== 3 &&
            parseInt(binId.toString().substr(1, 1), 10) === 0
        ) {
            rowNumber = 10;
        } else if (
            binId.toString().length === 3 &&
            parseInt(binId.toString().substr(2, 1), 10) === 0
        ) {
            rowNumber = 10;
        } else {
            rowNumber = parseInt(
                binId.toString().substr(binId.toString().length - 1, 1),
                10
            );
        }
    } else {
        rowNumber = parseInt(binId, 10);
    }
    return rowNumber;
};

module.exports = {
    getParams
}


// WEBPACK FOOTER //
// ./src/components/assign-prescriptions/common/helpers.fn.js